import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import StatsBar from "../components/StatsBar";
import Services from "../components/Services";
import Projects from "../components/Projects";
import WhyChooseUs from "../components/WhyChooseUs";
import About from "../components/About";
import Testimonials from "../components/Testimonials";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import SocialFloat from "../components/SocialFloat";

const HomePage = () => {
  return (
    <div className="bg-[#F7F5F2] text-[#0F0F0F] min-h-screen" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <StatsBar />
        <Services />
        <Projects />
        <WhyChooseUs />
        <About />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <SocialFloat />
    </div>
  );
};

export default HomePage;
